<script>
import Layout from '@layouts/main.vue'



import Grid from '@components/grid.vue'

import axios from 'axios'

import _ from 'underscore'

import moment from 'moment'

import { getFlightConfig } from '@utils/helpers.js'

import Fls from '@components/flight/FlsData.vue'

const filterObj = {
  filter: 'agTextColumnFilter',
  filterParams: {
    applyButton: false,
    resetButton: true,
  },
  resizable: true,
  sortable: true,
}

const columnDefs = [
  { field: 'PaxName', pinned: true, width: 250, ...filterObj },
  { field: 'PaxType', headerName: 'MFCI', width: 75, ...filterObj },
  { field: 'PaxDestination', headerName: 'Destination', ...filterObj },
  { field: 'Class', width: 75, ...filterObj },
  {
    field: 'SeatNumber',
    headerName: 'Seat',
    cellClass: 'text-center',
    headerClass: 'text-center',
    ...filterObj,
  },
  {
    field: 'SequenceNumber',
    headerName: 'Seq',
    cellClass: 'text-center',
    valueFormatter: (params) => {
      return params.value ? (params.value + '').padStart(3, '0') : ''
    },
  },
  { field: 'PaxStatus', ...filterObj },
  {
    field: 'BaggagePieces',
    headerName: 'Bags',
    filter: 'agNumberColumnFilter',
    cellClass: 'text-right',
    headerClass: 'text-right',
    pinned: false,
    width: 75,
    sortable: true,
  },
  {
    field: 'BaggageWeight',
    headerName: 'Weight',
    filter: 'agNumberColumnFilter',
    cellClass: 'text-right',
    pinned: false,
    width: 75,
    sortable: true,
  },
]

export default {
  page() {
    return {
      title: this.user.name,
      meta: [
        {
          name: 'description',
          content: `The user profile for ${this.user.name}.`,
        },
      ],
    }
  },
  components: { Layout, Grid, Fls },
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      columnDefs: columnDefs,
      paxFilter: null,
      gridData: [],
      paxData: [],
      bayData: [],
      lastUpdated: [
        { type: 'paxlist', timestamp: null },
        { type: 'baysplit', timestamp: null },
      ],
      isLoading: false,
      sideBarVisible: true,
      flightId: null,
      paxStates: [
        { caption: 'Booked', state: false },
        { caption: 'Checked', state: false },
        { caption: 'Boarded', state: false },
        { caption: 'Cancelled', state: false },
      ],
    }
  },
  computed: {
    filterStatus() {
      const filters = this.paxStates
        .filter((state) => state.state)
        .map((state) => {
          return state.caption.toUpperCase()
        })
      return filters
    },
    flight() {
      return this.$store.getters['flights/getFlightById'](this.flightId)
    },
    totalBaggage() {
      return _.reduce(
        this.flight.BagTotals,
        (memo, obj) => {
          return memo + obj.TotalPieces
        },
        0
      )
    },
    totalBaggageWeight() {
      return _.reduce(
        this.flight.BagTotals,
        (memo, obj) => {
          return memo + obj.TotalWeight
        },
        0
      )
    },
  },
  watch: {
    '$route.params.flightId': {
      immediate: true,
      handler(flightId) {
        this.flightId = flightId
        this.getData(flightId)
      },
    },
    paxStates: {
      deep: true,
      handler() {
        const flightId = this.$route.params.flightId
        this.getData(flightId)
      },
    },
  },
  beforeMount() {
    if (!this.flight) {
      this.$router.push('/flights')
    }
  },
  methods: {
    getFlightConfig: getFlightConfig,
    moment(date, format) {
      return moment(date).format(format)
    },
    getReducedMFCI(data) {
      return {
        M: _.reduce(
          data,
          (memo, obj) => {
            return memo + obj.CkdMale
          },
          0
        ),
        F: _.reduce(
          data,
          (memo, obj) => {
            return memo + obj.CkdFemale
          },
          0
        ),

        C: _.reduce(
          data,
          (memo, obj) => {
            return memo + obj.CkdChild
          },
          0
        ),
        I: _.reduce(
          data,
          (memo, obj) => {
            return memo + obj.CkdInfant
          },
          0
        ),
      }
    },
    getReducedBagTotals(data) {
      return {
        totalPieces: _.reduce(
          data,
          (memo, obj) => {
            return memo + obj.TotalPieces
          },
          0
        ),
        totalWeight: _.reduce(
          data,
          (memo, obj) => {
            return memo + obj.TotalWeight
          },
          0
        ),
      }
    },
    getData(flightId) {
      if (!flightId) {
        flightId = this.$route.params.flightId
      }
      this.isLoading = true
      axios
        .get(`${this.$config.apiBaseUrl}pax/flightid/${flightId}`)
        .then((response) => {
          const data = response.data.Results[0]
          // Update the timestamp
          const paxlist = this.lastUpdated.findIndex(
            (obj) => obj.type === 'paxlist'
          )
          this.lastUpdated[paxlist].timestamp = response.data.Timestamp

          data.forEach((element, index) => {
            element.id = index
          })
          // filter pax status
          // Get an array of selected pax statuses
          const selectedPaxStatus = this.paxStates.filter(
            (_status) => _status.state
          )
          // Map the caption (rather than the state)
          const paxStatusFilters = selectedPaxStatus.map((_status) =>
            _status.caption.toUpperCase()
          )
          // Process data
          if (paxStatusFilters.length) {
            this.paxData = data.filter((_pax) => {
              const x = paxStatusFilters.indexOf(_pax.PaxStatus)
              if (x > -1) {
                return _pax
              }
            })
          } else {
            this.paxData = data
          }
        })
        .catch((error) => {
          console.log(error)
          const paxlist = this.lastUpdated.findIndex(
            (obj) => obj.type === 'paxlist'
          )
          this.lastUpdated[paxlist].timestamp = 'FAILED'
        })
        .finally(() => (this.isLoading = false))
    },
  },
}
</script>

<template>
  <Layout :last-updated="lastUpdated">
    <div class="content-container">
      <div v-if="sideBarVisible" id="sidebar-collapse" class="sidebar collapse">
        <div class="sidebar-content container">
          <div class="app-sidebar text-small">
            <Fls :flight="flight" />
            <div class="app-sidebar-bottom"></div>
          </div>
        </div>
      </div>

      <div class="chat-module" data-filter-list="chat-module-body">
        <div class="toolbar row p-2">
          <div class="col-4">
            <input
              v-model="paxFilter"
              class="form-control form-control-sm"
              type="text"
              placeholder="Passenger Search (All Columns)"
            />
          </div>
          <button
            class="btn btn-sm btn-primary btn-refresh mr-2"
            :disabled="isLoading"
            @click="getData($route.params.flightId)"
          >{{ isLoading ? 'Refreshing...' : 'Refresh' }}</button>

          <b-button-group size="sm">
            <b-button
              v-for="(btn, idx) in paxStates"
              :key="idx"
              :pressed.sync="btn.state"
              variant="primary"
            >{{ btn.caption }}</b-button>
          </b-button-group>
        </div>
        <Grid
          :column-defs="columnDefs"
          :quick-filter="paxFilter"
          :grid-data="paxData"
          filter-col="PaxStatus"
        />
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.toolbar {
  background: #f5f7f7;
}
.totals-row {
  display: flex;
  justify-content: space-evenly;
}
hr {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}

.flight-status.FINALIZED {
  background: #1c2b36;
  padding: 1px 5px;
  border-radius: 2px;
  color: white;
}

.text-lg {
  font-size: 1.2rem;
}
</style>
